module.exports = __webpack_public_path__ + "img/bianzu.279411c2.png";